<section class="case-studies-page animate-fade-in-up">
    <div class="case-studies-page__shell">
        <header class="case-studies-page__head">
            <p class="case-studies-page__eyebrow">Enterprise Validation</p>
            <h1 class="case-studies-page__title">Case Studies.</h1>
            <p class="case-studies-page__copy">
                Discover how we drive operational efficiency and structural business transformation for global
                enterprises.
            </p>
        </header>

        @if (loading) {
        <div class="case-studies-page__status case-studies-page__status--loading">Loading case studies...</div>
        }

        @if (!loading && caseStudies.length > 0) {
        <div class="case-studies-grid" role="list" aria-label="Case studies list">
            @for (caseStudy of caseStudies; track caseStudy.id) {
            <article class="case-studies-card" role="listitem">
                <button class="case-studies-card__button" type="button"
                    [attr.aria-label]="'Read full study for ' + caseStudy.clientName"
                    (click)="openCaseStudy(caseStudy.id)">
                    <div class="case-studies-card__tag-row">
                        <span class="case-studies-card__tag">{{ caseStudy.tag }}</span>
                    </div>
                    <h2 class="case-studies-card__title">{{ caseStudy.title }}</h2>
                    <p class="case-studies-card__client">Client: {{ caseStudy.clientName }}</p>
                    <p class="case-studies-card__overview">{{ caseStudy.overview }}</p>

                    <div class="case-studies-card__footer">
                        <span>Read Full Study</span>
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </div>
                </button>
            </article>
            }
        </div>
        }

        @if (!loading && caseStudies.length === 0) {
        <div class="case-studies-page__status">No case studies found.</div>
        }

        @if (!loading && totalCount > 0) {
        <div class="case-studies-pagination">
            <div class="case-studies-pagination__summary">
                Showing {{ startItem }} to {{ endItem }} of {{ totalCount }} results
            </div>
            @if (totalPages > 1) {
            <div class="case-studies-pagination__controls">
                <button class="case-studies-pagination__arrow" type="button" aria-label="Previous page"
                    (click)="goToPreviousPage()" [disabled]="page === 1">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                </button>
                @for (item of paginationItems; track item) {
                @if (item === '...') {
                <span class="case-studies-pagination__dots">...</span>
                }
                @if (item !== '...') {
                <button class="case-studies-pagination__page" type="button"
                    [class.case-studies-pagination__page--active]="page === item" (click)="goToPage(+item)">
                    {{ item }}
                </button>
                }
                }
                <button class="case-studies-pagination__arrow" type="button" aria-label="Next page"
                    (click)="goToNextPage()" [disabled]="page === totalPages">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M9 18l6-6-6-6"></path>
                    </svg>
                </button>
            </div>
            }
        </div>
        }
    </div>
</section>